/* Afford Adventskalender — Bühne, Für sie/Für ihn, Fassade, Dezember, Kaufleiste.
   Stichtag: Kalendertag in Europe/Berlin. ?adv_day=N simuliert den N. Dezember. */
(function () {
  'use strict';
  if (window.__advInit) return;
  window.__advInit = true;

  var desktop = window.matchMedia('(min-width: 768px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var tickers = [];

  function today() {
    var o = {};
    new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(new Date()).forEach(function (p) { o[p.type] = +p.value; });
    var t = { y: o.year, m: o.month, d: o.day };
    var sim = parseInt(new URLSearchParams(location.search).get('adv_day'), 10);
    if (sim >= 1 && sim <= 31) t = { y: t.y, m: 12, d: sim };
    return t;
  }
  function daysUntil(t, day) { return Math.round((Date.UTC(t.y, 11, day) - Date.UTC(t.y, t.m - 1, t.d)) / 864e5); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function pinProgress(section) {
    var r = section.getBoundingClientRect();
    var run = r.height - section.firstElementChild.offsetHeight;
    return run > 0 ? clamp(-r.top / run, 0, 1) : 0;
  }

  var T = today();
  var openUpTo = T.m === 12 ? Math.min(T.d, 24) : 0;
  var line = 'herren';
  var WEEKDAYS = ['Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag', 'Montag']; // ab 1.12.2026

  /* ---------- Bühne ---------- */
  document.querySelectorAll('[data-adv-stage]').forEach(function (stage) {
    var img = stage.querySelector('[data-adv-photo]');
    var stageVisible = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { stageVisible = e[0].isIntersecting; }).observe(stage);
    tickers.push(function () {
      if (still.matches || !img || !stageVisible) return;
      var r = stage.getBoundingClientRect();
      img.style.setProperty('--adv-zoom', (1 + clamp(-r.top / Math.max(1, r.height), 0, 1) * 0.08).toFixed(4));
    });

    var cd = stage.querySelector('[data-adv-countdown]');
    if (cd) {
      var toFirst = daysUntil(T, 1);
      if (toFirst > 0) {
        cd.innerHTML = 'Noch <b>' + toFirst + '</b> ' + (toFirst === 1 ? 'Tag' : 'Tage') + ' bis zum ersten Türchen.';
        cd.hidden = false;
      } else if (openUpTo > 0 && openUpTo < 24) {
        cd.innerHTML = 'Heute ist Türchen <b>' + openUpTo + '</b> dran. Verpasste holst du einfach nach.';
        cd.hidden = false;
      }
    }

    // Kaufleiste: per IntersectionObserver statt Layout-Abfragen bei jedem Scroll-Schritt
    var sticky = stage.querySelector('[data-adv-sticky]');
    var card = stage.querySelector('.adv-s__glass');
    if (sticky && card && 'IntersectionObserver' in window) {
      var past = false, atEnd = false;
      var sync = function () { sticky.classList.toggle('is-on', past && !atEnd); };
      new IntersectionObserver(function (e) {
        past = !e[0].isIntersecting && e[0].boundingClientRect.bottom < 0; sync();
      }).observe(card);
      var fin = document.querySelector('.adv-fin');
      if (fin) {
        new IntersectionObserver(function (e) {
          atEnd = e[0].isIntersecting || e[0].boundingClientRect.top < 0; sync();
        }, { rootMargin: '0px 0px -30% 0px' }).observe(fin);
      }
    }
  });

  /* ---------- Zeigerlicht auf dem Glas ---------- */
  document.querySelectorAll('[data-adv-light]').forEach(function (el) {
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--lgx', (e.clientX - r.left) + 'px');
      el.style.setProperty('--lgy', (e.clientY - r.top) + 'px');
    });
    el.addEventListener('pointerleave', function () {
      el.style.removeProperty('--lgx');
      el.style.removeProperty('--lgy');
    });
  });

  /* ---------- Fassade ---------- */
  var pop = document.querySelector('[data-adv-pop]');
  var activeSpot = null;

  function fillPop(day) {
    var d = +day;
    var open = d <= openUpTo;
    var wait = daysUntil(T, d);
    pop.innerHTML = '<span class="adv-c__pop-no">Türchen ' + d + '</span>' +
      '<strong class="adv-c__pop-name">' + (open ? 'Ist schon offen.' : 'Öffnet am ' + WEEKDAYS[(d - 1) % 7] + ', ' + d + '. Dezember.') + '</strong>' +
      (open ? '' : '<span class="adv-c__pop-note">Noch ' + wait + ' ' + (wait === 1 ? 'Tag' : 'Tage') + '.</span>');
  }
  function placePop(spot) {
    var art = spot.parentElement;
    var aw = art.clientWidth, ah = art.clientHeight;
    var x = parseFloat(spot.style.left) / 100 * aw;
    var y = parseFloat(spot.style.top) / 100 * ah;
    if (!desktop.matches) { pop.style.left = ''; pop.style.top = ''; pop.style.transform = ''; return; }
    var w = pop.offsetWidth;
    pop.style.left = clamp(x, w / 2 + 10, aw - w / 2 - 10) + 'px';
    pop.style.top = y + 'px';
    pop.style.transform = y > ah * 0.58 ? 'translate(-50%, calc(-100% - 26px))' : 'translate(-50%, 26px)';
  }
  function openSpot(spot) {
    if (activeSpot) activeSpot.classList.remove('is-active');
    activeSpot = spot;
    spot.classList.add('is-active');
    fillPop(spot.dataset.advSpot);
    pop.hidden = false;
    placePop(spot);
  }
  function closePop() {
    if (!pop) return;
    pop.hidden = true;
    if (activeSpot) activeSpot.classList.remove('is-active');
    activeSpot = null;
  }
  document.querySelectorAll('[data-adv-spot]').forEach(function (spot, i) {
    spot.style.setProperty('--i', i);
    spot.addEventListener('click', function (e) {
      e.stopPropagation();
      if (activeSpot === spot) closePop(); else openSpot(spot);
    });
  });
  document.addEventListener('click', function (e) { if (pop && !pop.contains(e.target)) closePop(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
  window.addEventListener('resize', function () { if (activeSpot) placePop(activeSpot); });

  /* ---------- Für sie / Für ihn ---------- */
  var lineBtns = document.querySelectorAll('[data-adv-line-btn]');
  function setLine(next) {
    line = next;
    document.querySelectorAll('.adv-switch').forEach(function (s) { s.dataset.line = next; });
    lineBtns.forEach(function (b) {
      var on = b.dataset.advLineBtn === next;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && b.dataset.variant) {
        document.querySelectorAll('form[id^="adv-form-"] [name="id"]').forEach(function (inp) { inp.value = b.dataset.variant; });
      }
    });
    document.querySelectorAll('[data-adv-line-list]').forEach(function (l) { l.hidden = l.dataset.advLineList !== next; });
    document.querySelectorAll('[data-adv-line-label]').forEach(function (el) { el.textContent = next === 'damen' ? 'Für sie' : 'Für ihn'; });
    document.querySelectorAll('[data-adv-line-text]').forEach(function (el) { el.textContent = el.dataset[next] || el.textContent; });
    window.dispatchEvent(new Event('adv:line'));
    if (activeSpot) fillPop(activeSpot.dataset.advSpot);
  }
  lineBtns.forEach(function (b) {
    b.addEventListener('click', function (e) { e.stopPropagation(); setLine(b.dataset.advLineBtn); });
  });

  /* ---------- Einblenden (Preisbalken) ---------- */
  var reveals = document.querySelectorAll('[data-adv-reveal]');
  if ('IntersectionObserver' in window) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    reveals.forEach(function (el) { rio.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Scroller: alle Düfte der gewählten Linie ---------- */
  document.querySelectorAll('[data-adv-scroller]').forEach(function (sec) {
    var space = sec.querySelector('.adv-sc__space');
    var from = sec.querySelector('[data-adv-sc-from]');
    var dist = 0;
    function track() { return sec.querySelector('[data-adv-sc-track]:not([hidden])'); }

    function measure() {
      var t = track();
      if (!t) return;
      if (!desktop.matches) { space.style.height = ''; t.style.transform = ''; return; }
      dist = Math.max(0, t.scrollWidth - window.innerWidth + 48);
      space.style.height = Math.round(dist * 0.8) + 'px';
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    window.addEventListener('adv:line', function () { measure(); request(); });

    tickers.push(function () {
      var t = track();
      if (!t || !desktop.matches) return;
      t.style.transform = 'translate3d(' + (-pinProgress(sec) * dist).toFixed(1) + 'px,0,0)';
      var items = t.querySelectorAll('[data-adv-sc-item]');
      for (var i = 0; i < items.length; i++) {
        if (items[i].getBoundingClientRect().right > 80) { from.textContent = items[i].dataset.advScItem; break; }
      }
    });
  });

  /* ---------- Schnee: wenige, langsame Flocken in der Bühne ----------
     Startet erst nach dem Laden der Seite, zeichnet in drei Tiefenebenen
     (drei Füllungen pro Bild statt einer pro Flocke) und läuft auf dem
     Handy mit 30 Bildern pro Sekunde. */
  document.querySelectorAll('[data-adv-snow]').forEach(function (cv) {
    if (still.matches || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var layers = [], W = 0, H = 0, running = false, visible = false, ready = false, last = 0;
    var dpr = desktop.matches ? Math.min(window.devicePixelRatio || 1, 2) : 1;
    var minGap = desktop.matches ? 0 : 40;
    var DEPTHS = [{ r: 1.1, v: 0.32, a: 0.4 }, { r: 1.9, v: 0.55, a: 0.6 }, { r: 2.8, v: 0.85, a: 0.8 }];
    function size() {
      W = cv.clientWidth; H = cv.clientHeight;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(desktop.matches ? 80 : 27, W * H / 16000));
      layers = DEPTHS.map(function (d) {
        var fl = [];
        for (var i = 0; i < Math.ceil(n / 3); i++) fl.push({ x: Math.random() * W, y: Math.random() * H, p: Math.random() * 6.28 });
        return { d: d, fl: fl };
      });
    }
    function step(ts) {
      if (!running) return;
      requestAnimationFrame(step);
      if (ts - last < minGap) return;
      var k = last ? Math.min(3, (ts - last) / 16.7) : 1;
      last = ts;
      ctx.clearRect(0, 0, W, H);
      for (var l = 0; l < layers.length; l++) {
        var L = layers[l], d = L.d;
        ctx.beginPath();
        for (var i = 0; i < L.fl.length; i++) {
          var f = L.fl[i];
          f.y += d.v * k; f.p += 0.01 * k; f.x += Math.sin(f.p) * 0.3 * k;
          if (f.y > H + 4) { f.y = -4; f.x = Math.random() * W; }
          ctx.moveTo(f.x + d.r, f.y);
          ctx.arc(f.x, f.y, d.r, 0, 6.283);
        }
        ctx.fillStyle = 'rgba(255,255,255,' + d.a + ')';
        ctx.fill();
      }
    }
    function toggle() {
      var go = ready && visible && !document.hidden;
      if (go && !running) { running = true; last = 0; requestAnimationFrame(step); }
      if (!go) running = false;
    }
    function start() {
      var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); };
      idle(function () { size(); ready = true; toggle(); }, { timeout: 2500 });
    }
    window.addEventListener('resize', function () { if (ready) size(); });
    document.addEventListener('visibilitychange', toggle);
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; toggle(); }).observe(cv);
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  });

  /* ---------- Finale: Formular der Bühne abschicken ---------- */
  document.querySelectorAll('[data-adv-submit]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var form = document.querySelector('form[id^="adv-form-"]');
      if (!form) return;
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  });

  /* ---------- Angebot: Für ihn + Für sie zusammen in den Warenkorb ---------- */
  document.querySelectorAll('[data-adv-pair]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ids = btn.dataset.advPair.split(',');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: +id, quantity: 1 }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = root + 'cart';
      }).catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
    });
  });

  /* ---------- Kein Klaviyo-Popup auf der Adventskalender-Seite ---------- */
  (function () {
    var SEL = 'div[aria-label="POPUP Form"], div[aria-label="FLYOUT Form"], [data-testid="POPUP"], [data-testid="FLYOUT"], [class*="kl-teaser"]';
    function sweep() {
      var hit = false;
      document.querySelectorAll(SEL).forEach(function (el) {
        // äußersten Klaviyo-Container direkt unter <body> entfernen (inkl. Abdunklung)
        var top = el;
        while (top.parentElement && top.parentElement !== document.body) top = top.parentElement;
        if (top.parentElement === document.body && !top.matches('main, header, footer, [id^="shopify-section"]')) top.remove();
        else el.remove();
        hit = true;
      });
      if (hit) {
        [document.documentElement, document.body].forEach(function (n) {
          if (n.style.overflow === 'hidden') n.style.overflow = '';
        });
      }
    }
    if ('MutationObserver' in window) new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
    sweep();
  })();

  var queued = false;
  function frame() { queued = false; tickers.forEach(function (fn) { fn(); }); }
  function request() { if (!queued) { queued = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  request();
})();
